import React from 'react';
import './form-compound-field.scss';
import type { ReactFCC } from '@bbkAdminUtils/utility-types';

const FormCompoundField: ReactFCC = ({ children }) => (
  <div className="bbk-form-compound-field">{children}</div>
);

export default FormCompoundField;
